const Header = ({ children, primary }) => {
  return primary ? (
    <h1 className="header header__primary header--extra-bold">{children}</h1>
  ) : (
    <h2 className="header header__primary">{children}</h2>
  );
};

const Text = ({ children, primary, noList }) => {
  const className = 'text text__primary';

  return primary || noList ? (
    <div className={className}>{children}</div>
  ) : (
    <ul className={className}>{children}</ul>
  );
};

export default function Section({ title, primary = false, noList = false, children }) {
  return (
    <>
      <Header primary={primary}>{title}</Header>
      <Text primary={primary} noList={noList}>
        {children}
      </Text>
    </>
  );
}
